<template>
    <div class="stickyBar">
        <div class="list_container">
            <div v-for="(item, index) in listData" :key="index" @click="setActiopFunGroup(item)" class="centerAlign" >
                <!-- <img src="@/assets/themeFour/tab-bg.png" alt="" width="100%"> -->
                <div class="groupData" @click="goToGamePannel(item.id, item.groupType)">
                    <div class="group_item">
                        <img :src="item.customIcon" alt="">
                    </div>
                    <div class="group_name">
                        {{ $t(item.name) }}</div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="showGameList">
        <GamePopup ref="gameListRef" />
    </div>
</template>

<script setup lang="ts">
import { emitWithPreviewCheck, GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, onMounted, computed, onBeforeMount, watch, nextTick } from 'vue'
import GamePopup from '@/view/game/gamePopup.vue';

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = defineProps<{
    listData: GroupList[],
    itemData: {
        styles: {
            active_background_color: string,
            active_font_color: string,
            border_color: string,
            font_color: string
        }
    },
}>()
const localActiveItem = ref<string | number>('')
const gameListRef = ref()
const showGameList = ref(false)
const emits = defineEmits(['goToGamePanel'])
const activeItem = computed({
    get: () => localActiveItem.value || props.listData[0]?.id || '',
    set: (val) => {
        localActiveItem.value = val
    }
})
const goToGamePannel = (id: number | string, groupType: number) => {
    let data = {
        id: id,
        groupType: groupType
    }
    emitWithPreviewCheck(emits, 'goToGamePanel', data)
}

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = async (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
    await nextTick()
    gameListRef.value?.selectGroup(item)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}

defineExpose({
    setActiveItem,
    setActiopFunGroup
})

onBeforeMount(() => {
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})
</script>
<style scoped>
.list_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none !important;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    transition-property: transform;
    transition-duration: 0ms;
    margin: 5px 0 0;
    padding: 0 5px 0;
    border-radius: 10px;

}

.stickyBar {
    background-color: #002d2d;
    position: sticky;
    top: 125px;
    z-index: 99;
    margin: 0;
    padding: 0;
}

.list_container::-webkit-scrollbar {
    display: none;
}

.groupData {
    background-image: url('@/assets/themeFour/tab-bg.png');
    background-size: cover;
    height: 100px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: end;
    padding-bottom: 5px;
    width: 90px;
}

.group_item {
    flex-direction: column;
    position: relative;
    margin: 0 3px 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 60px;
    height: 25px;
}

.group_item img {
    max-width: 80%;
}

.group_name {
    text-align: center;
    font-size: 14px;
    padding-top: 5px;
    color: #fff;
    font-weight: bold;
}

.centerAlign {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 5px;
    position: relative;
}
</style>